import React, { Component } from 'react'
import { Table } from 'antd'
import moment from 'moment'

class ListChangeOrder extends Component {
  getColumns = () => {
    return [
      {
        title: 'Id',
        dataIndex: 'job',
        render: item => {
          if (item && item.job_type) {
            let jobUrl = `/jobView/${item.job_id}/${item.job_type.replace(
              '/',
              '-'
            )}/change-orders/modal/${item.id}`
            return (
              <a href={jobUrl} target="_blank">
                {item.id}
              </a>
            )
          }
        }
      },
      {
        title: 'Description',
        dataIndex: 'description'
      },
      {
        title: 'Status',
        dataIndex: 'status'
      },
      {
        title: 'Created Date',
        dataIndex: 'created_date'
      }
    ]
  }

  getData = () => {
    const { changeOrders } = this.props

    const data = changeOrders.map((changeOrder, index) => {
      // format date from db
      changeOrder.created_date = moment(new Date(changeOrder.created_date)).format('YYYY-MM-DD')
      const returnObj = Object.assign(
        {
          key: `${changeOrder.id}${index}`,
          job: {
            job_id: changeOrder.job_id,
            job_type: changeOrder.job_type,
            id: changeOrder.id
          }
        },
        changeOrder
      )
      return returnObj
    })
    return data
  }

  render() {
    return (
      <div>
        <h6>Change Order</h6>
        <Table
          pagination={false}
          columns={this.getColumns()}
          dataSource={this.getData()}
          size="small"
          style={{ backgroundColor: 'white' }}
        />
      </div>
    )
  }
}

export default ListChangeOrder



// WEBPACK FOOTER //
// ./src/components/reports/general/open-items/ListChangeOrder.js